import { LOCALES } from "../locales";

export default {
  [LOCALES.ENGLISH]: {
    "general.labelEN": "English",
    "general.labelES": "Spanish",
    "general.loading": "Loading",
    "header.logo": "JM",
    "header.title": "[Jobs Board: ReactJs + GraphQL Example Code]",
    "breadcrumb.menu.option1": "Home",
    "breadcrumb.menu.option2": "Job Detail: ",
    "footer.api": "Jobs Board API: ",
    "footer.created": "Created using:",
    "footer.getcode": "Get the code in ",
    "user.hi": "Hi, ",
    "user.guess": "Guess",
    "user.login": "Log In",
    "user.profile": "Profile",
    "user.settings": "Settings",
    "user.signout": "Sign Out",
    "user.alt.maybe": "Maybe later?",
    "user.alt.login": "Click to Log In",
    "user.alt.signout": "Click to Sign Out",
    "joblist.location": "Location:",
    "joblist.commitment": "Commitment:",
    "joblist.type": "Type:",
    "joblist.company": "Company:",
    "joblist.date": "Date:",
    "jobdetail.nodate":
      "We can't find the info for this Job. Please go back to the Home Page.",
  },
};
